export function getStrapiMediaUrl(path?: string | null): string | null {
  return path ? `${process.env.REACT_APP_STRAPI_BASE_URL}${path}` : null;
}
